export default {"src":"/_next/static/media/warranty.9b3e2934.svg","height":512,"width":512};